import type { JSX } from 'react'

import { InfoIcon, Tooltip, VisuallyHidden } from '@buffer-mono/popcorn'

import { useNoteMentionsEnabled } from '~publish/components/Notes'

import styles from './NotesVisibilityHint.module.css'

/** Who can read a Post's Notes. */
export const POST_NOTES_VISIBILITY =
  'Notes are visible for any team member with access to this channel.'
/** Who can read a draft's Notes: a draft has no channel to narrow it. */
export const DRAFT_NOTES_VISIBILITY =
  'Notes are visible for any team member in this organization.'

export function NotesVisibilityHint({
  buttonRef,
  tooltip = POST_NOTES_VISIBILITY,
}: {
  buttonRef?: { current: HTMLButtonElement | null }
  tooltip?: string
}): JSX.Element | null {
  const mentionsEnabled = useNoteMentionsEnabled()
  if (!mentionsEnabled) return null

  return (
    <Tooltip content={tooltip}>
      <button
        ref={(node) => {
          if (buttonRef) buttonRef.current = node
        }}
        className={styles.infoHint}
        type="button"
      >
        <InfoIcon size="xsmall" />
        <VisuallyHidden>About note visibility</VisuallyHidden>
      </button>
    </Tooltip>
  )
}
